/**
 * Adds an artificial delay in development to simulate slow networks/servers.
 *
 * Vue CLI only exposes env vars prefixed with `VUE_APP_` to the client bundle,
 * so use `.env.local` with:
 *   VUE_APP_SLOW_LOAD_MS=1500
 */
export async function maybeSlowLoad(): Promise<void> {
  if (process.env.NODE_ENV === 'production') return;

  const ms = Number(process.env.VUE_APP_SLOW_LOAD_MS ?? 0);
  if (!Number.isFinite(ms) || ms <= 0) return;

  await new Promise<void>(resolve => setTimeout(resolve, ms));
}

